import { useContext, useEffect, useState } from "react";
import MinusRed from "../../../../Assets/StorefrontIcons/MinusRed.svg";
import { closeModal } from "../../../../Features/inventoryManagementSlice";
import { useDispatch } from "react-redux";
import { getDefaultFormObjectByCategory } from "../../../AddSizeChart/SizeChartFormsData";
import { getSizeChartColumnWidth } from "../../../../lib/utils/utils";
import { EditSizeChartContext } from "../../../../Context/EditSizeChartContext";
import HeaderSection from "../../../AddSizeChart/Modals/ColumnRemoveModal/HeaderSection";
import InputSection from "../../../AddSizeChart/Modals/ColumnRemoveModal/InputSection";

function ColumnRemoveModal() {
    const dispatch = useDispatch();
    const [localData, setLocalData] = useState([]);
    const [categoryKeys, setCategoryKeys] = useState([]);
    const { selectedCategory, sizeChartFormData, setSizeChartFormData } = useContext(EditSizeChartContext);

    const handleRemoveColumn = (key) => {
        const updatedData = localData.map((item) => {
            const newItem = { ...item };
            delete newItem[key];
            return newItem;
        });
        setLocalData(updatedData);
    };

    useEffect(() => {
        if (sizeChartFormData.length > 0) {
            setLocalData(JSON.parse(JSON.stringify(sizeChartFormData)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (localData.length === 0) return;

        const categoryItems = getDefaultFormObjectByCategory(selectedCategory);
        const baseKeys = Object.keys(categoryItems || {}).filter((k) => k !== "id");
        const currentKeys = Object.keys(localData[0]).filter((k) => k !== "id");

        const mergedKeys = [
            ...baseKeys.filter((key) => currentKeys.includes(key)),
            ...currentKeys.filter((key) => !baseKeys.includes(key)),
        ];

        setCategoryKeys(mergedKeys);
    }, [selectedCategory, localData]);

    const handleSave = () => {
        setSizeChartFormData(localData);
        dispatch(closeModal());
    };

    const handleCloseModal = () => {
        dispatch(closeModal());
    };

    const formatHeaderTitle = (text) => {
        if (!text) return "";
        return text.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();
    };

    return (
        <div className="max-w-full flex flex-col gap-3">
            <div className="w-full flex flex-col gap-3 overflow-x-scroll">
                <div className="w-fit flex items-center">
                    {categoryKeys.map((key) =>
                        key === "sizeName" ? (
                            <div key={key} className="w-[180px]" />
                        ) : (
                            <div key={key} className="w-[180px] flex justify-center">
                                <button onClick={() => handleRemoveColumn(key)} className="py-2">
                                    <img src={MinusRed} alt="remove" />
                                </button>
                            </div>
                        )
                    )}
                </div>

                <div className="w-fit flex items-center rounded-lg border border-[#EAEAEA]">
                    {categoryKeys.map((key, index) => {
                        const isLast = index === categoryKeys.length - 1;
                        const columnWidth = getSizeChartColumnWidth(key, selectedCategory);

                        if (key === "sizeName") {
                            return (
                                <div
                                    key={key}
                                    className={`w-[180px] ${columnWidth || ""} h-[94px] shrink-0 px-6 py-3 flex items-center justify-center ${
                                        !isLast ? "border-r border-[#EAEAEA]" : ""
                                    }`}
                                >
                                    <p>Size</p>
                                </div>
                            );
                        }

                        return (
                            <HeaderSection
                                key={`header-${key}`}
                                isLast={isLast}
                                title={formatHeaderTitle(key)}
                                externalCSS={columnWidth}
                            />
                        );
                    })}
                </div>

                <div className="max-h-80 flex flex-col gap-3">
                    {localData.length > 0 &&
                        localData.map((row) => (
                            <div key={row.id} className="flex items-center w-fit">
                                <div className="flex items-center rounded-lg border border-[#EAEAEA]">
                                    {categoryKeys.map((key, keyIndex) => {
                                        const isLastColumn = keyIndex === categoryKeys.length - 1;
                                        const columnWidth = getSizeChartColumnWidth(key, selectedCategory);

                                        if (key === "sizeName") {
                                            return (
                                                <div
                                                    key={`${row.id}-${key}`}
                                                    className={`w-[180px] ${columnWidth || ""} shrink-0 px-6 py-3 ${
                                                        !isLastColumn ? "border-r border-[#EAEAEA]" : ""
                                                    }`}
                                                >
                                                    <p
                                                        className={`${
                                                            row.sizeName ? "" : "text-[#A0A0A0]"
                                                        } w-full text-center`}
                                                    >
                                                        {row.sizeName || "input"}
                                                    </p>
                                                </div>
                                            );
                                        }

                                        return (
                                            <InputSection
                                                key={`${row.id}-${key}-input`}
                                                isLast={isLastColumn}
                                                externalCSS={columnWidth}
                                                centimeters={row?.[key]?.cm || ""}
                                                inches={row?.[key]?.in || ""}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            <div className="flex items-center justify-end gap-2">
                <button
                    onClick={handleCloseModal}
                    className="px-5 py-[10px] rounded text-[#757575] text-base font-semibold outline-none"
                >
                    Cancel
                </button>

                <button
                    onClick={handleSave}
                    className="px-5 py-[10px] rounded text-white bg-primaryColor hover:bg-primaryAccent text-base font-semibold outline-none"
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default ColumnRemoveModal;
